import Blaze from "@swiggy-private/blaze.js";
import { ErrorInfo } from "react";
import { getNRErrorInfo } from "@swiggy-private/js-utils";

export const filterHeadersFromSwiggyHeaders = (swiggyHeaders: Record<string, string | undefined>) => {
    return {
        deviceId: swiggyHeaders?.deviceid || swiggyHeaders?.deviceId || "--",
        sid: swiggyHeaders?.sid || "--",
        tid: swiggyHeaders?.tid || "--",
        userId: swiggyHeaders?.userid || swiggyHeaders?.userId || "--",
        platform: swiggyHeaders?.platform || "--",
        appVersionCode: swiggyHeaders?.["version-code"] || "--",
    };
};

export const sendCustomNREvViaBlaze = (
    type: string,
    body = {},
    headers?: Record<string, string | undefined> | void,
) => {
    const swgyHeaders = headers ? filterHeadersFromSwiggyHeaders(headers) : {};
    Blaze.recordCustomEvent({
        eventType: "portal_static_page_renderer",
        href: window.location.href,
        type,
        ...body,
        ...swgyHeaders,
    });
};

export const sendErrorBoundaryEvent = (
    error?: Error,
    errorInfo?: ErrorInfo,
    headers?: Record<string, string | undefined> | void,
) => {
    const swgyHeaders = headers ? filterHeadersFromSwiggyHeaders(headers) : {};
    const errorBoundaryEvents = getNRErrorInfo(error, errorInfo);
    Blaze.recordCustomEvent({
        eventType: "webview_error_boundary",
        appName: "portal_static_page_renderer",
        ...errorBoundaryEvents,
        ...swgyHeaders,
    });
};
